import { Robot } from '../../interface/Robot';
import { ROBOT_SELECTED } from './types';

export const setRobotSelected = (robot: Robot | null) => ({
  type: ROBOT_SELECTED,
  payload: robot,
});
